export default  {"src":"/_next/static/image/public/assets/images/bg-logo.da5d64d59ec5cd944968043d9f13ea28.svg","height":130,"width":341};